module.exports = __webpack_public_path__ + "static/media/aluxion.970a9bb5.svg";